import { render, staticRenderFns } from "./publish_notice.vue?vue&type=template&id=d700d146&scoped=true"
import script from "./publish_notice.vue?vue&type=script&lang=js"
export * from "./publish_notice.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/publish_notice.css?vue&type=style&index=0&id=d700d146&prod&scoped=true&lang=css&external"
import style1 from "./publish_notice.vue?vue&type=style&index=1&id=d700d146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d700d146",
  null
  
)

export default component.exports